package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.model.project.process.state.AdvanceInvoiceProcessStateEntry.AdvanceInvoiceProcessStates
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry.AssemblyBasementPreparationProcessStates
import it.neckar.lizergy.model.project.process.state.AssemblyBasementProcessStateEntry.AssemblyBasementProcessStates
import it.neckar.lizergy.model.project.process.state.AssemblyPortfolioProcessStateEntry.AssemblyPortfolioProcessStates
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry.AssemblyRoofPreparationProcessStates
import it.neckar.lizergy.model.project.process.state.AssemblyRoofProcessStateEntry.AssemblyRoofProcessStates
import it.neckar.lizergy.model.project.process.state.BlueprintAcquisitionProcessStateEntry.BlueprintAcquisitionProcessStates
import it.neckar.lizergy.model.project.process.state.BlueprintProcessStateEntry.BlueprintProcessStates
import it.neckar.lizergy.model.project.process.state.ConfigurationProcessStateEntry.ConfigurationProcessStates
import it.neckar.lizergy.model.project.process.state.DocumentationProcessStateEntry.DocumentationProcessStates
import it.neckar.lizergy.model.project.process.state.FinalAccountProcessStateEntry.FinalAccountProcessStates
import it.neckar.lizergy.model.project.process.state.FinishingUpProcessStateEntry.FinishingUpProcessStates
import it.neckar.lizergy.model.project.process.state.GridAssessmentProcessStateEntry.GridAssessmentProcessStates
import it.neckar.lizergy.model.project.process.state.OrderSpecialMaterialProcessStateEntry.OrderSpecialMaterialProcessStates
import it.neckar.lizergy.model.project.process.state.PresentationProcessStateEntry.PresentationProcessStates
import it.neckar.lizergy.model.project.process.state.ProjectProcessStateEntry.ProjectProcessStates
import it.neckar.lizergy.model.project.process.state.QuoteConfirmationProcessStateEntry.QuoteConfirmationProcessStates
import it.neckar.lizergy.model.project.process.state.QuoteOfferProcessStateEntry.QuoteOfferProcessStates
import it.neckar.lizergy.model.project.process.state.StartupOperationsProcessStateEntry.StartupOperationsProcessStates
import it.neckar.lizergy.model.project.process.state.SwitchMeterBoxProcessStateEntry.SwitchMeterBoxProcessStates
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

object LizergyProcessStatesBrowserSerializer : KSerializer<LizergyProcessStates> {
  override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor("LizergyProcessStatesNIT", PrimitiveKind.STRING)

  override fun serialize(encoder: Encoder, value: LizergyProcessStates) {
    encoder.encodeString("${value::class.simpleName}::${(value as Enum<*>).name}")
  }

  override fun deserialize(decoder: Decoder): LizergyProcessStates {
    val string = decoder.decodeString()
    val (enumClass, enumName) = string.split("::")
    return when (enumClass) {
      "AdvanceInvoiceProcessStates" -> AdvanceInvoiceProcessStates.valueOf(enumName)
      "AssemblyBasementPreparationProcessStates" -> AssemblyBasementPreparationProcessStates.valueOf(enumName)
      "AssemblyBasementProcessStates" -> AssemblyBasementProcessStates.valueOf(enumName)
      "AssemblyPortfolioProcessStates" -> AssemblyPortfolioProcessStates.valueOf(enumName)
      "AssemblyRoofPreparationProcessStates" -> AssemblyRoofPreparationProcessStates.valueOf(enumName)
      "AssemblyRoofProcessStates" -> AssemblyRoofProcessStates.valueOf(enumName)
      "BlueprintAcquisitionProcessStates" -> BlueprintAcquisitionProcessStates.valueOf(enumName)
      "BlueprintProcessStates" -> BlueprintProcessStates.valueOf(enumName)
      "ConfigurationProcessStates" -> ConfigurationProcessStates.valueOf(enumName)
      "DocumentationProcessStates" -> DocumentationProcessStates.valueOf(enumName)
      "FinalAccountProcessStates" -> FinalAccountProcessStates.valueOf(enumName)
      "FinishingUpProcessStates" -> FinishingUpProcessStates.valueOf(enumName)
      "GridAssessmentProcessStates" -> GridAssessmentProcessStates.valueOf(enumName)
      "OrderSpecialMaterialProcessStates" -> OrderSpecialMaterialProcessStates.valueOf(enumName)
      "PresentationProcessStates" -> PresentationProcessStates.valueOf(enumName)
      "ProjectProcessStates" -> ProjectProcessStates.valueOf(enumName)
      "QuoteConfirmationProcessStates" -> QuoteConfirmationProcessStates.valueOf(enumName)
      "QuoteOfferProcessStates" -> QuoteOfferProcessStates.valueOf(enumName)
      "StartupOperationsProcessStates" -> StartupOperationsProcessStates.valueOf(enumName)
      "SwitchMeterBoxProcessStates" -> SwitchMeterBoxProcessStates.valueOf(enumName)

      else -> throw IllegalArgumentException("Unknown enum class: $enumClass")
    }
  }
}
